import { blogPosts } from "./blogData";
import { projectsData } from "./projectsData";
import { servicesData } from "./servicesData";
import { teamData } from "./teamData";

export const searchIndex = [
  ...blogPosts.map((item) => ({
    type: "blog",
    title: item.title,
    excerpt: item.contentExtra || item.content?.[0]?.value || "",
    url: `/bai-viet/${item.slug}`,
  })),
  ...projectsData.map((item) => ({
    type: "project",
    title: item.title,
    excerpt: item.shortDescription || item.overviewText?.[0] || "",
    url: `/du-an/${item.slug}`,
  })),
  ...servicesData.map((item) => ({
    type: "service",
    title: item.title,
    excerpt: item.overviewText || item.topSections?.[1]?.text || "",
    url: `/dich-vu/${item.slug}`,
  })),
  ...teamData.map((item) => ({
    type: "team",
    title: item.name,
    excerpt: item.position || item.about,
    url: `/doi-ngu/${item.slug}`,
  })),
];
